'use strict';

export default function bodyElement($rootScope, $state, $document) {
  'ngInject';

  const bodyEl = angular.element($document[0].body);
  let addedClass;

  $rootScope.$on('$stateChangeSuccess', (event, newState) => {
    if (addedClass) {
      bodyEl.removeClass(addedClass);
    }

    addedClass = newState.data && newState.data.bodyClass;
    if (addedClass) {
      bodyEl.addClass(addedClass);
    }
  });

  return {
    getElement: function () {
      return bodyEl;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/body_element.js